// Get product compare elements
const $compareTable = $('.product-comparison-table');
const $compareControls = $('.product-comparison-controls input');
const $compareCells = $('[data-product-comparison-cell]');
const $compareAnnouncement = $('.product-comparison-announcement');
const controlsOverCapacityMessage = $('.product-comparison-controls').data('over-capacity-message');
const controlsCapacity = $('.product-comparison-controls').data('capacity');

// Register change event on compare controls
$compareControls.change(compareControlChange);

// Update table cells on page load
updateCompareTable();

// Change event for compare controls
function compareControlChange(e) {
  const $changedControl = $(e.target);
  const checkedControlCount = $compareControls.filter(':checked').length;

  if ($changedControl.is(':checked') && checkedControlCount > controlsCapacity) {
    $changedControl.prop('checked', false);
    alert(controlsOverCapacityMessage);
  } else {
    updateCompareTable();
  }
}

// Update compare table based on the checked compare controls
function updateCompareTable() {

  const $checkedCompareControls = $compareControls.filter(':checked');

  // Get checked compare IDs
  const checkedCompareIds = $checkedCompareControls
    .map(function() {
      return $(this).data('product-comparison-control');
    })
    .get();

  // Get checked compare titles
  const checkedCompareTitles = $checkedCompareControls
    .map(function() {
      return $(this).data('product-title');
    })
    .get();

  // Get checked compare cells
  const checkedCompareCellsSelector = checkedCompareIds
    .map(id => `[data-product-comparison-cell="${id}"]`)
    .join(',');
  const $checkedCompareCells = $compareCells
    .filter(checkedCompareCellsSelector);

  // Only show checked compare cells
  $compareCells.hide();
  $checkedCompareCells.show();

  // Hide the compare table if there are no checked compare cells
  $compareTable.toggle($checkedCompareCells.length > 0);

  // Set compare info text
  const compareInfoProductTitles = checkedCompareTitles.length === 0 ? $compareAnnouncement.data('no-products-text') : checkedCompareTitles.join(', ');
  $compareAnnouncement.text(`${$compareAnnouncement.data('comparing-products-text')}: ${compareInfoProductTitles}`);
}

// hack: remove empty rows from table
$('.product-comparison-table tbody tr').each(function() {
  if ($(this).find('td.empty').length === $(this).find('td').length) {
  	$(this).remove();
  }
});
